module.exports = __webpack_public_path__ + "static/media/open-accordion.817f7319.svg";